import styled from 'styled-components';

import imageSources from '../../../constants/imageSources/imageSources';

export const Div = styled.div`
    display: inline-block;
    width: 36px;
    height: 36px;
    margin-right: ${(props) => (props.index === 3 ? '0px' : '12px')};
    margin-bottom: 12px;
    cursor: url("${({ isEnabled }) => (isEnabled ? imageSources.ICONS.GRAB_CURSOR : imageSources.ICONS.LOCK_OUTLINE)}"), default;
    cursor: ${({ isEnabled }) => (isEnabled ? 'grab' : 'not-allowed')}};
    box-sizing: border-box;
    background-image: url("${(props) => props.imageSource}");
    background-position: center;
    opacity: ${({ isDragging }) => (isDragging ? 0.25 : 1)};
    transition: transform .2s ease-in;
    :hover {
        border-radius: 5px;
        border: ${({ isEnabled, border }) => (isEnabled ? `1px solid ${border}` : 'none')};
        box-shadow: 0px 0px 4px rgba(28, 28, 28, 0.2);
        transform: rotateZ(-3deg);
    }
`;

export const Img = styled.img`
    width: 36px;
    height: 36px;
    padding: 0px;
`;

export const ElementsCollection = styled.div`
    margin-top: 12px;
    pointer-events: ${(props) => (props.isCanvasEmpty ? 'none' : null)};
    opacity: ${(props) => (props.isCanvasEmpty ? '0.1' : '1')};
`;

export const TooltipText = styled.span`
    font-weight: bold;
`;
